import { useMutation } from "@apollo/client";
import React from "react";
import environment from "../../env";
import { completeTokenizationSchema } from "../../graphql/mutations/completeTokenization";
import {
  paymentCallbackError,
  paymentCredentails,
} from "../../store/nanostore";

export const useCompleteTokenization = () => {
  const variables = {
    variables: { ...environment.paymentService },
  };
  const [completeTokenization, request] = useMutation(
    completeTokenizationSchema,
    {
      ...variables,
      onError: (error, clientOptions) => {
        paymentCallbackError.set(error);
      },
      fetchPolicy: "no-cache",
    }
  );

  const complete = (email: string, phoneNumber: string, other: any = {}) => {
    completeTokenization({
      variables: {
        input: { emailOrPhone: { email, phoneNumber }, ...other },
      },
    });
  };
  return { complete, request };
};
